import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "full-content",
  lang: "ru"
}
const _hoisted_2 = { class: "page-content full-content__page" }

import MainFooter from '@/views/MainFooter.vue';
import MainHeader from '@/views/MainHeader.vue';
import SideMenu from '@/views/SideMenu.vue';
import contentHeader from './common/components/snedson-material-components/content-header/content-header.vue';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
    const theme = localStorage.getItem('theme');

    if (theme === 'dark') {
        document.documentElement.className = 'dark-theme';
    } else {
        document.documentElement.className = '';
    }
});

//document.documentElement.className = "dark-theme" // uncomment for dark theme by default

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(SideMenu),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(contentHeader),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(MainFooter)
    ])
  ], 64))
}
}

})